import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'wp-user-profile-preview',
  templateUrl: './user-profile-preview.component.html',
  styleUrls: ['./user-profile-preview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserProfilePreviewComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
